module.exports = __webpack_public_path__ + "static/assets/0e2daa03eaf0b07ce495414ac3daf337.png";